import { render, staticRenderFns } from "./RatingsEnter.vue?vue&type=template&id=6080c1ff&scoped=true"
import script from "./RatingsEnter.vue?vue&type=script&lang=js"
export * from "./RatingsEnter.vue?vue&type=script&lang=js"
import style0 from "./RatingsEnter.vue?vue&type=style&index=0&id=6080c1ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6080c1ff",
  null
  
)

export default component.exports